import { Briefcase, Mail, Shield } from "lucide-react";

import { useAuth } from "@/auth/useAuth";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { SectionCard } from "@/components/ui/section-card";
import { Separator } from "@/components/ui/separator";

export function MePage() {
  const { user, memberships, isAdmin } = useAuth();
  if (!user) return null;

  const initials = user.name
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-6">
      <header className="flex items-center gap-4">
        <Avatar className="h-16 w-16">
          {user.avatar_url ? (
            <AvatarImage src={user.avatar_url} alt={user.name} />
          ) : null}
          <AvatarFallback className="text-base">{initials}</AvatarFallback>
        </Avatar>
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-ink-950">
            {user.name}
          </h1>
          <p className="flex items-center gap-1 text-sm text-ink-500">
            <Mail className="h-4 w-4" /> {user.email}
          </p>
        </div>
      </header>

      <Separator />

      <SectionCard
        title={
          <span className="flex items-center gap-2">
            <Shield className="h-4 w-4 text-brand-500" /> Permissões
          </span>
        }
      >
        <ul className="space-y-1 text-sm text-ink-900">
          <li>
            <strong>Administrador global:</strong> {isAdmin ? "Sim" : "Não"}
          </li>
          <li>
            <strong>Filtro PII:</strong>{" "}
            {user.pii_filter_enabled ? "Ativo" : "Desativado"}
          </li>
        </ul>
      </SectionCard>

      <SectionCard
        title={
          <span className="flex items-center gap-2">
            <Briefcase className="h-4 w-4 text-brand-500" /> Times
          </span>
        }
      >
        {memberships.length === 0 ? (
          <p className="text-sm text-ink-500">
            Você ainda não foi adicionado a nenhum time.
          </p>
        ) : (
          <ul className="space-y-2 text-sm">
            {memberships.map((m) => (
              <li
                key={m.team.id}
                className="flex items-center justify-between rounded-xl border border-line bg-canvas px-3 py-2"
              >
                <span className="text-ink-900">{m.team.name}</span>
                <span className="rounded-full bg-brand-50 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-brand-700">
                  {m.role}
                </span>
              </li>
            ))}
          </ul>
        )}
      </SectionCard>
    </div>
  );
}
